import { upgradeArray } from '@sigma-legacy-libs/essentials/lib/utils'

export const locales = upgradeArray([ 'en', 'ru', 'es' ])
